module.exports = __webpack_public_path__ + "img/icon_bms9.b15d0a70.jpg";